export default __webpack_public_path__ + "static/media/psd.d502abe4.svg";